<template>
  <div class="error-404-page">
    <h1
      class="error-title"
      data-testid="error-title"
    >
      Error 404: Page Not Found
    </h1>
    <h2 class="error-subtitle">
      Oops! The page you are looking for does not exist.
    </h2>
  </div>
</template>

<script>
export default {
  name: 'Error404Page',
};
</script>

<style scoped>
.error-404-page {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.error-title {
    font-size: 36px;
    color: #333;
}

.error-subtitle {
    font-size: 24px;
    color: #666;
    margin-top: 10px;
}
</style>
